import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';

class ScrollToTop extends Component {
  componentDidUpdate() {
    window.scrollTo(0, 0);
  }
  render() {
    return this.props.children;
  }
}
ScrollToTop.propTypes = {
  children: PropTypes.element
};
ScrollToTop.defaultProps = {
  children: null
};

export default ScrollToTop;
